import p1_img from './1.jpg'
import p2_img from './2.jpg'
import p3_img from './3.jpg'
import p4_img from './4.jpg'
import p5_img from './5.jpg'
import p6_img from './6.jpg'
import p7_img from './7.jpg'
import p8_img from './8.jpg'
import p9_img from './9.jpg'
import p10_img from './10.jpg'
import p11_img from './11.jpg'



import p1_1_img from './1_1.jpg'
import p1_2_img from './1_2.jpg'
import p1_3_img from './1_3.jpg'

import p2_1_img from './2_1.jpg'
import p2_2_img from './2_2.jpg'
import p2_3_img from './2_3.jpg'

import p3_1_img from './3_1.jpg'
import p3_2_img from './3_2.jpg'
import p3_3_img from './3_3.jpg'

import p4_2_img from './4_2.jpg'
import p4_3_img from './4_3.jpg'
import p4_4_img from './4_4.jpg'

import p5_1_img from './5_1.jpg'
import p5_2_img from './5_2.jpg'
import p5_3_img from './5_3.jpg'

import p6_1_img from './6_1.jpg'
import p6_2_img from './6_2.jpg'
import p6_3_img from './6_3.jpg'

import p7_1_img from './7_1.jpg'
import p7_2_img from './7_2.jpg'
import p7_3_img from './7_3.jpg'

import p8_1_img from './8_1.jpg'
import p8_2_img from './8_2.jpg'
import p8_3_img from './8_3.jpg'

import p9_1_img from './9_1.jpg'
import p9_2_img from './9_2.jpg'
import p9_3_img from './9_3.jpg'

import p10_1_img from './10_1.jpg'
import p10_2_img from './10_2.jpg'
import p10_3_img from './10_3.jpg'

import p11_1_img from './11_1.jpg'
import p11_2_img from './11_2.jpg'
import p11_3_img from './11_3.jpg'

let all_product = [
  {
    id: 1,
    name: "Where artistry meets elegance: A hand-embroidered black chiffon dream.",
    image: p1_img,
    new_price: 6999,
    old_price: 8999,
     images: [p1_img, p1_1_img, p1_2_img, p1_3_img],

  },
  {
    id: 2,
    name: "Mystical elegance: Where purple chiffon dances with hand-embroidered artistry",
    image: p2_img,
    new_price: 6999,
    old_price: 8999,
     images: [p2_img, p2_1_img, p2_2_img, p2_3_img],
  },
  {
    id: 3,
    name: "Like a cloud of dreams: Sky blue chiffon, hand-embroidered with ethereal grace",
    image: p3_img,
    new_price: 6499,
    old_price: 7999,
     images: [p3_img, p3_1_img, p3_2_img, p3_3_img],
  },
  {
    id: 4,
    name: "A breath of springtime: Hand-embroidered pastel green chiffon, a vision of fresh elegance",
    image: p4_img,
    new_price: 6799,
    old_price: 8499,
     images: [p4_img, p4_2_img, p4_3_img, p4_4_img],
  },
  {
    id: 5,
    name: "Untouched elegance: Hand-embroidered white chiffon, a canvas of pure sophistication.",
    image: p5_img,
    new_price: 6999,
    old_price: 8999,
     images: [p5_img, p5_1_img, p5_2_img, p5_3_img],
  },
    {
      id: 6,
      name: "Ignite the night: Hand-embroidered red chiffon, a blaze of captivating passion",
      image: p6_img,
      new_price: 6999,
      old_price: 8999,
       images: [p6_img, p6_1_img, p6_2_img, p6_3_img],
  
    },
      {
        id: 7,
        name: "A shade of serenity: Where this unique grey chiffon meets delicate hand embroidery.",
        image: p7_img,
        new_price: 6499,
        old_price: 7999,
         images: [p7_img, p7_1_img, p7_2_img, p7_3_img],
      },
      {
        id: 8,
        name: "Let Raag Neela sing to your soul: A dark blue chiffon dress, a poetic expression of elegance",
        image: p8_img,
        new_price: 6499,
        old_price: 7999,
         images: [p8_img, p8_1_img, p8_2_img, p8_3_img],
      },
      {
        id: 9,
        name: "The heart of the forest: Where dark green chiffon meets the rich artistry of hand embroidery",
        image: p9_img,
        new_price: 5799,
        old_price: 6999,
         images: [p9_img, p9_1_img, p9_2_img, p9_3_img],
      },
      {
        id: 10,
        name: "Blushing beauty: A hand-embroidered peach chiffon dream",
        image: p10_img,
        new_price: 6499,
        old_price: 7999,
         images: [p10_img, p10_1_img, p10_2_img, p10_3_img],
      },
      {
        id: 11,
        name:"Jewel-toned elegance: A hand-embroidered peacock blue chiffon masterpiece" ,
        image: p11_img,
        new_price: 6499,
        old_price: 7999,
         images: [p11_img, p11_1_img, p11_2_img, p11_3_img],
      },
];


export default all_product;
